export class HttpStreamError extends Error {
  readonly __isHttpStreamError = true
  status: number
  code?: string
  details?: unknown

  constructor(opts: { status: number; message: string; code?: string; details?: unknown }) {
    super(opts.message)
    this.name = 'HttpStreamError'
    Object.setPrototypeOf(this, new.target.prototype) // ensure prototype chain
    this.status = opts.status
    this.code = opts.code
    this.details = opts.details
  }
}

export function isHttpStreamError(err: unknown): err is HttpStreamError {
  return typeof err === 'object' && err !== null && '__isHttpStreamError' in err
}
